exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ImageSingle-module__image___933U6{width:100%;padding-bottom:68%;position:relative;border-radius:10px;overflow:hidden}.ImageSingle-module__image___933U6 img{height:100%;width:100%;-o-object-fit:contain;object-fit:contain;position:absolute}", ""]);

// exports
exports.locals = {
	"image": "ImageSingle-module__image___933U6"
};